import React from 'react'

import EditSectionForm from '../../modules/Section/components/EditSectionForm'
export default function EditBranchPage() {
  return <EditSectionForm />
}
